import { useState } from "react";
import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { AccordionDetailsProps } from "@mui/material/AccordionDetails";
import MuiAccordionDetails from "@mui/material/AccordionDetails";

export const FAQAccordionDetails = styled(
  ({ onClick, question, children, ref, ...rest }: AccordionDetailsProps & { question: string; onClick?: () => void }) => {
    const [text, setText] = useState<string>("");

    return (
      <MuiAccordionDetails {...rest}>
        <Typography
          variant="subtitle2"
          gutterBottom
          component="div"
          style={{
            fontWeight: "bold",
          }}
        >
          {text}
        </Typography>

        <Typography variant="body2" gutterBottom>
          {question}
        </Typography>
      </MuiAccordionDetails>
    );
  },
)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));
